import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getAppControlStore from "../../stores/firebase-store/app-control";
import UnderConstruction from "./UnderConstruction";
import UpdatingVersion from "./UpdatingVersion";

const BlockerPages = withLiteObserverAndTheme(() => {
  // Existing REST-polled maintenance/version-update state - untouched.
  const isRestVersionUpdateActive =
    !getCorePersonalStore().adminCurrentVersionIsActive.get();
  const isRestMaintenanceActive =
    getCorePersonalStore().adminUnderMaintenance.get();

  // Additional Firebase App Control trigger, combined via OR with REST.
  const isFirebaseMaintenanceActive =
    getAppControlStore().isFirebaseMaintenanceActive.get();
  const isFirebaseVersionUpdateActive =
    getAppControlStore().isFirebaseVersionUpdateActive.get();

  const adminShouldUpdate =
    isRestVersionUpdateActive || isFirebaseVersionUpdateActive;
  const adminIsUnderMaintenance =
    isRestMaintenanceActive || isFirebaseMaintenanceActive;

  // Same priority as before: maintenance beats version-update.
  const shoulShowUpdate = adminShouldUpdate && !adminIsUnderMaintenance;
  return shoulShowUpdate ? (
    <UpdatingVersion isFirebaseTriggered={!isRestVersionUpdateActive} />
  ) : adminIsUnderMaintenance ? (
    <UnderConstruction />
  ) : null;
});
export default BlockerPages;
